// ** Type Import
import { OwnerStateThemeType } from "../";

const ToggleButton = () => {
  return {
    MuiToggleButtonGroup: {
      styleOverrides: {
        root: ({ ownerState, theme }: OwnerStateThemeType) => ({}),
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: ({ ownerState, theme }: OwnerStateThemeType) => ({
          "&.Mui-selected": {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.common.white,
          },
        }),
      },
    },
  };
};

export default ToggleButton;
